import services from './services';
import {
	lg,
	cloneDeep,
	util,
	isCorrectVal,
	isDate
} from 'utils';
import {
	GetProvinces,
	GetCitys,
	GetAreas,
	GetAgentList,
	GetParmConfig, //寄送，支付接口
	GetProductClass,
	GetAgentConsigneeList,
	Consignee_Add,
	GetEmployList,
	ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import viewDialog from './viewDialog/index.vue'
import stockDialog from './stockDialog/index.vue' //物流信息
import networkModalDialog from '@pages/Network/networkCheck/components/networkModalDialog/index.vue'
export default {
	mixins: [services],
	components: {
		viewDialog,
		networkModalDialog,
		stockDialog
	},
	data() {
		return {
			Session: util.getSessin(),
			queryDelivery: [{
					TypeName: "-请选择-",
					TypeValue: ''
				},
				{
					TypeName: "未发货",
					TypeValue: 0
				},
				{
					TypeName: "部分发货",
					TypeValue: 1
				},
				{
					TypeName: "全部发货",
					TypeValue: 2
				}
			],
			PayTypes: [{
				"Id": -1,
				"ParmName": "全部"
			}, {
				"Id": 1,
				"ParmName": "支付宝"
			}, {
				"Id": 4,
				"ParmName": "微信"
			}, {
				"Id": 5,
				"ParmName": "pos机"
			}, {
				"Id": 8,
				"ParmName": "其他"
			}, {
				"Id": 6,
				"ParmName": "淘宝"
			}, {
				"Id": 9,
				"ParmName": "微店"
			}],
			queryType: [{
				TypeName: "全部",
				TypeValue: -1
			}, {
				TypeName: "未配置",
				TypeValue: 6
			}, {
				TypeName: "已配置",
				TypeValue: 13
			}],
			netTypes: [{
				id: 0,
				name: '未开启'
			}, {
				id: 1,
				name: '设备安装'
			}, {
				id: 2,
				name: '网络检测'
			}, {
				id: 10,
				name: '已完成网络检测 '
			}],
			stadus: [{
				TypeName: "全部",
				TypeValue: -1
			}, {
				TypeName: "待审核",
				TypeValue: 1
			}, {
				TypeName: "审核通过",
				TypeValue: 6
			}, {
				TypeName: "审核不通过",
				TypeValue: 12
			}],
			orderType: [{
				id: 1,
				name: "H5"
			}, {
				id: 2,
				name: "普通"
			}, {
				id: 3,
				name: "转介绍"
			}, {
				id: 4,
				name: "团购"
			}, {
				id: 5,
				name: "小程序"
      }],
      packageTypes: [{
				id: 10002,
				name: "2018联帮在家ABC"
			}, {
				id: 10003,
				name: "联帮在家Q3Q4续费"
			}],
			loading: false,
			lists: [],
			pageIndex: 1,
			pageSize: 10,
			totalSize: '',
			sels: [], //列表选中列
			pageSizes: [10, 20, 50],
			query: this.getFormData()

		}
	},
	methods: {
		getFormData() {
			return cloneDeep({
				OrderCode: "",
				UserName: "",
				startDate: "",
				endDate: "",
				endDate: "",
				OrderStatus: -1,
				payType: -1,
				userTel: '',
				babyName: '',
				babyId: '',
				sendStatus: '',
				AgentName: '',
				C_Name: '',
				NetCheckStatus: '',
				PayCode: '',
				SchoolName: '',
				OrderSource: '',
        PackageId:''
			});
		},
		//配置资源
		handleAudit(index, row) {
			this.$refs.refViewDialog.show({
				OrderId: row.OrderId,
				title: '配置资源',
				isReadOnly: false,
				PackageId: row.PackageId
			})
		},
		//查看订单
		handleView(index, row) {
			this.$refs.refViewDialog.show({
				OrderId: row.OrderId,
				title: '订单详情',
				isReadOnly: true,
				PackageId: row.PackageId
			})
		},
		// 修改
		handleEdit(index, row) {
			this.$router.push({
				path: "/Order/LBHomeOrder",
				query: {
					OrderId: row.OrderId,
					isReadOnly: true
				}
			});
		},
		handleDel(index, row) {
			this.$confirm('确认删除吗？', '提示', {}).then(() => {
				this.DelList(row.OrderId)
			})
		},
		// 查看物流信息
		handleStock(index, row) {
			this.$refs.refStockDialog.show({
				OrderId: row.OrderId,
				title: '查看物流信息'
			})
		},
		//查询
		onQuerySubmit: function () {
			this.pageIndex = 1;
			this.getList();
		},
		//查询功能
		handleSizeChange: function (val) {
			this.pageSize = val;
			this.getList();
		},
		// 网络检测情况点击
		NetworkView(row) {
			this.$refs.refsModalDialog.show({
				Id: row.NetWorkCheckId,
				title: '查看',
				isFollow: false
			})
		},
		//导出
		download() {
			this.$confirm('确认导出吗？', '提示', {}).then(() => {
				this.getList();
				var params = {
					Sid: this.$store.state.sysSid,
					Session: this.$store.state.sysSession,
					pageIndex: this.pageIndex,
					pageSize: this.pageSize,
				};
				for (let item in this.query) {
					let value = this.query[item];
					if (value != '') {
						params[item] = value;
					}
				}
				// GET /api/UserOrder/UserOrderExport
				util.exportToFileV2("api/UserOrder/UserOrderExport", params, this);
			});
		},
		onQueryClean: function () {
			this.query = this.getFormData();
			this.getList();
		},
		handleCurrentChange: function (val) {
			this.pageIndex = val;
			this.getList();
		}
	},
	created() {
		this.getList();
	},

}


// WEBPACK FOOTER //
// ./src/pages/Family/OrderList/vm.js